"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderType = void 0;
var OrderType;
(function (OrderType) {
    OrderType["FIRSTTIME"] = "FIRSTTIME";
    OrderType["LRP"] = "LRP";
    OrderType["LRPNOW"] = "LRPNOW";
    OrderType["STANDARD"] = "STANDARD";
    OrderType["RETURN"] = "RETURN";
    OrderType["FREE"] = "FREE";
    OrderType["REPLACEMENT"] = "REPLACEMENT";
    OrderType["REFUND"] = "REFUND";
    OrderType["CHARGE"] = "CHARGE";
    OrderType["DRAFT"] = "DRAFT";
    OrderType["MISCREFUND"] = "MISCREFUND";
    OrderType["MISCCHARGE"] = "MISCCHARGE";
    OrderType["NFR"] = "NFR";
    OrderType["OTG"] = "OTG";
})(OrderType || (exports.OrderType = OrderType = {}));
